import axios, {AxiosInstance} from 'axios';

class StrapiApi {
    private static axiosInstance: AxiosInstance = axios.create({
        baseURL: process.env.NEXT_PUBLIC_LINK_STRAPI,
        headers: {
            'Content-Type': 'application/json',
        },
    });

    static async getPolicies() {
        try {
            const response = await this.axiosInstance.get(`/collection-pages?publicationState=live`);
            return response.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    }

    static async getPartnerBrandings() {
        try {
            const response = await this.axiosInstance.get(
                '/partner-brandings?publicationState=live&filters[is_active][$eq]=true&populate=partner_logo',
            );
            return response.data?.data || [];
        } catch (err) {
            console.error(err);
            return [];
        }
    }

    static async getTermsAndConditions() {
        try {
            const response = await this.axiosInstance.get(
                '/terms-and-conditions-page?populate=*&publicationState=live',
            );
            return response.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    }

    static async getPrivacyPolicy() {
        try {
            const response = await this.axiosInstance.get('/privacy-policy');
            return response.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    }
}

export default StrapiApi;
